import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "../../services/auth.service";
import { RestService } from "../../services/rest.service";

@Component({
  selector: "app-profile-modal-user-detail",
  templateUrl: "./profile-modal-user-detail.component.html",
  styleUrls: ["./profile-modal-user-detail.component.scss"]
})
export class ProfileModalUserDetailComponent implements OnInit {
  closeResult: string;
  @Input() mode: any;
  @Input() user: any;
  @Output() userUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Output() userDeleted: EventEmitter<any> = new EventEmitter<any>();

  errors = "";
  buttonText = "";
  buttonClasses = [];
  isUpdateMode = false;
  isDeleteMode = false;
  isActiveModal = true;
  isSuccessfullyUpdated = false;
  isSuccessfullyDeleted = false;
  form_is_valid = false;

  form = new FormGroup({
    email: new FormControl("", [
      Validators.required,
      Validators.pattern("^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[a-z]{2,4}$")
    ]),
    title: new FormControl("", [Validators.required]),
    first_name: new FormControl("", Validators.required),
    last_name: new FormControl("", Validators.required),
    phone_number: new FormControl("", Validators.required),
    user_permissions: new FormControl("", Validators.required)
  });

  validatorError(field) {
    const fieldObjectErrors = this.form.get(field).errors;
    if (fieldObjectErrors == null) {
      return "";
    }
    return Object.keys(fieldObjectErrors)[0];
  }

  constructor(
    private modalService: NgbModal,
    private auth: AuthService,
    private rest: RestService
  ) {}

  // permissions are view/read/all

  fieldIsRequired(field) {
    return this.form.controls[field].validator !== null;
  }

  public choose(value: string) {
    console.log("CHOOSING");
    console.log(value);
  }

  resetWindowStatus() {
    this.isSuccessfullyUpdated = false;
    this.isSuccessfullyDeleted = false;
  }

  open(content: any) {
    this.resetWindowStatus();
    this.isActiveModal = true;
    this.errors = "";
    /* NG ON INIT BETWEEN THESE LINES */
    switch (this.mode) {
      case "UPDATE":
        // console.log("OPENING UPDATE");
        break;
      case "DELETE":
        // console.log("OPENING DELETE");
        break;
    }
    /*  NO MORE NG ON INIT */
    this.modalService
      .open(content, { size: "lg", ariaLabelledBy: "modal-basic-title" })
      .result.then(
        result => {
          this.closeResult = `Closed with: ${result}`;
          console.log(this.closeResult);
          this.errors = "";
        },
        reason => {
          console.log("REASON");
          console.log(reason);
          // if (reason == 'unset_submission_complete') this.pageStatus.submission_complete = false;
          // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  ngOnInit() {
    switch (this.mode) {
      case "UPDATE":
        this.buttonText = "Edit";
        this.buttonClasses = ["btn-sm", "btn-outline-info"];
        this.resetWindowStatus();
        this.isUpdateMode = true;
        this.form.setValue({
          email: this.user.email,
          title: this.user.title,
          first_name: this.user.first_name,
          last_name: this.user.last_name,
          phone_number: this.user.phone_number,
          user_permissions: this.user.user_permissions
        });
        this.form.valueChanges.subscribe(data => {
          this.form_is_valid = this.form.valid;
        });
        // this.form.valueChanges.subscribe((data) => {
        //   [ "username"
        //   , "repeat_login"
        //   , "email"
        //   , "title"
        //   , "first_name"
        //   , "last_name"
        //   , "phone_number"
        //   , "user_permissions"
        //   ].forEach((field) => {
        //       const formField = this.form.get(field);
        //       const value = (formField == null || formField == undefined)? '' : formField.value;
        //   });
        // }
        break;
      case "DELETE":
        this.buttonText = "Delete";
        this.buttonClasses = ["btn-sm", "btn-outline-danger"];
        this.isUpdateMode = false;
        this.isDeleteMode = true;
        break;
    }
  }
}
